export default __webpack_public_path__ + "media/images/react_icons/logout-044864f156f130b5a8853c7d23d6052c.svg";